import { Identifiable, Project, Zone } from "@planzone/dto";

function groupByZone(
  projects: (Identifiable<Project> & { zone: Identifiable<Zone> })[],
): (Identifiable<Zone> & { projects: Identifiable<Project>[] })[] {
  return Object.values(
    projects.reduce<{
      [key: string]: Identifiable<Zone> & { projects: Identifiable<Project>[] };
    }>(
      (map, { zone, ...project }) => ({
        ...map,
        [zone.uuid]: (!!map[zone.uuid]
          ? {
              ...map[zone.uuid],
              projects: [...map[zone.uuid].projects, project],
            }
          : { ...zone, projects: [project] }) as Identifiable<Zone> & {
          projects: Identifiable<Project>[];
        },
      }),
      {},
    ),
  );
}

export { groupByZone };
